/*jshint unused:false*/
/*global fetch */
/*global console */

//object fit fix for ie11
var userAgent, ieReg, ie;
userAgent = window.navigator.userAgent;
ieReg = /msie|Trident.*rv[ :]*11\./gi;
ie = ieReg.test(userAgent);


if(ie) {
  var imgContainer = document.querySelectorAll(".img-container");

  for(var i=0; i<imgContainer.length; i++){
    var imgCtr = imgContainer[i];
    var imgUrl = imgCtr.getElementsByTagName("img")[0].src;
    if (imgUrl) {
      imgCtr.setAttribute("style", "background-image:url('" + imgUrl + "')");
      imgCtr.classList.add("custom-object-fit");
    }
  }
}

// Price toggles
// let allSwitches = [].slice.call(document.querySelectorAll('.price-toggle'));
// let priceContainers = [].slice.call(document.querySelectorAll('.deal-price-toggle'));
// let priceSwitchForm = document.getElementById('price-switch');
// let selected;
// allSwitches.forEach((value) => {
//   value.addEventListener('change', (val) => {
//     (val.composedPath()[0].classList.contains('toggle-personal')) ? selected = 0 : selected = 1;
//     if(val.composedPath()[0].classList.contains('price-toggle-checkbox')){
//       (val.target.checked === true) ? selected = 1 : selected = 0;
//     }
//     toggleSwitches();
//     togglePrices();
//     updatePrice();
//   })
// })
// let toggleSwitches = () => {
//   allSwitches.forEach((v) => {
//     (selected === 0) ? v.querySelector('.toggle-personal').checked = true : v.querySelector('.toggle-business').checked = true;
//     (selected === 0) ? document.querySelector('#price-toggle-checkbox').checked = false : document.querySelector('#price-toggle-checkbox').checked = true;
//   })
//   document.querySelector("#switch-price-type").value = (selected === 0) ? 'Personal' : 'Business';
//   document.querySelectorAll(".price-title-type").forEach((v) => {
//     v.innerHTML = (selected === 0) ? 'Personal' : 'Business';
//   })
// }
// let togglePrices = () => {
//   priceContainers.forEach((v) => {
//     (selected === 0) ? v.querySelector('.price-personal').classList.add('active') : v.querySelector('.price-personal').classList.remove('active');
//     (selected === 1) ? v.querySelector('.price-business').classList.add('active') : v.querySelector('.price-business').classList.remove('active');
//   })
// }
// let updatePrice = () => {
//   let url = priceSwitchForm.getAttribute('action');
//   let formData = new FormData(priceSwitchForm);
//   fetch(url, {
//     method: 'POST',
//     processData: false,
//     contentType: false,
//     body: formData,
//     headers: {
//       'X-CSRF-TOKEN': document.querySelector("#price-switch [name=_token]").value,
//       'X-Requested-With': 'XMLHttpRequest'
//     },
//   }).then(
//     function(response) {
//       if (response.status !== 200) {
//         console.log('Looks like there was a problem. Status Code: ' + response.status);
//         return;
//       }
//       response.json().then(function(data) {
//         document.querySelector("#price-switch [name=_token]").value = data.token;
//       });
//     }
//   ).catch(function(err) {
//     console.log('Fetch Error :-S', err);
//   });
// }
// End price Toggles

// Back to top button
const scrollToTopButton = document.getElementById('back_to_top');
let smoothScrollCapture = (x) => {
  event.preventDefault();
  let id = x.currentTarget.target.getAttribute('href').split("#")[1]
  let el = document.getElementById(id);
  var x = el.getBoundingClientRect().left;
  var y = el.getBoundingClientRect().top;
  smoothScrollFunc(x, y)
}

let smoothScrollFunc = (x, y) => {
  event.preventDefault();
  window.scrollTo({
    top: y,
    left: x,
    behavior: 'smooth'
  });
}

window.addEventListener('DOMContentLoaded', () => {
  scrollToTopButton.addEventListener('click', () => {
    smoothScrollFunc(0, 0);
  })
})

window.addEventListener('scroll', () => {
  let pageHeight = document.body.scrollHeight;
  let currentHeight = window.scrollY;
  (currentHeight > (pageHeight/2)) ? scrollToTopButton.classList.add('active') : scrollToTopButton.classList.remove('active');
})
// End back to top button

/* MOBILE MODALS */
const navContainer = document.querySelector('.nav-container');
const hamburger = document.querySelector('#hamburger');
const hamburgerSearch = document.querySelector('#headerSearch');

const modalMobileNav = new tingle.modal({
  footer: false,
  closeMethods: ['escape'],
  cssClass: ['mobile-nav','reversed'],
  onOpen: function () {
    // Navigation height
    let headerHeight = document.querySelector('.site-header').offsetHeight + document.querySelector('.mobile-nav').offsetHeight;
    document.querySelector('.mobile-nav.tingle-modal').style.marginTop = headerHeight + 'px';

    hamburgerSearch.classList.remove('is-active');
  }
});
modalMobileNav.setContent(document.querySelector('.site-menu').innerHTML);

let searchOpened = false;
const modalMobileSearch = new tingle.modal({
  closeMethods: [],
  cssClass: ['mobile-search','reversed'],
  onOpen: function() {
    // Navigation height
    let headerHeight = document.querySelector('.site-header').offsetHeight + document.querySelector('.mobile-nav').offsetHeight;
    document.querySelector('.mobile-search.tingle-modal').style.marginTop = headerHeight + 'px';

    hamburger.classList.remove('is-active');
    document.querySelector('.mobile-search .tingle-modal-box__content').classList.add('search-bar', 'search-bar-dark', 'active');
    this.setContent(document.querySelector('#search-bar').innerHTML);
    document.querySelector('#search-bar').innerHTML = "";
    loadSearchForm();
    searchOpened = true;
  },
  onClose: function () {
    if (searchOpened) {
      document.querySelector('#search-bar').innerHTML = document.querySelector('.mobile-search .tingle-modal-box__content').innerHTML;
      this.setContent('');
      loadSearchForm();
      searchOpened = false;
    }
  }
});

// Nav modal
const handleToggle = () => {
  hamburger.classList.toggle('is-active');
  navContainer.classList.toggle('is-active');

  if(hamburger.classList.contains("is-active")) {
    modalMobileSearch.close();
    modalMobileNav.open();
  } else{
    modalMobileNav.close();
  }
}

hamburger.onclick = () => handleToggle();
hamburger.addEventListener('keyup', (event) => {
  if(event.keyCode === 13 || event.keyCode === 32) {
    handleToggle();
  }
});

// Search modal
const handleToggleSearch = () => {
  hamburgerSearch.classList.toggle('is-active');

  if(hamburgerSearch.classList.contains("is-active")) {
    modalMobileNav.close();
    modalMobileSearch.open();
  } else{
    modalMobileSearch.close();
  }
}
hamburgerSearch.onclick = () => handleToggleSearch();
hamburgerSearch.addEventListener('keyup', (event) => {
  if(event.keyCode === 13 || event.keyCode === 32) {
    handleToggleSearch();
  }
});
/* END MOBILE MODALS */

// Sticky class for navbar & modal
// window.onscroll = function() {stickyNav()};
// let navbar = document.getElementById('navbar');
// let tingleModal = document.querySelector('.tingle-modal');
// let sticky = navbar.offsetTop;
// function stickyNav() {
//   if (!document.body.classList.contains('tingle-enabled')) {
//     console.log(window.pageYOffset)
//     console.log(sticky)
//     if (window.pageYOffset > sticky) {
//       navbar.classList.add('is-sticky')
//       tingleModal.classList.add('is-sticky')
//     } else {
//       navbar.classList.remove('is-sticky')
//       tingleModal.classList.remove('is-sticky')
//     }
//   }
// }

hamburger.onclick = () => handleToggle();
hamburger.addEventListener('keyup', (event) => {
  if(event.keyCode === 13 || event.keyCode === 32) {
    handleToggle();
  }
});
/* END MOBILE MODALS */

  // Toggle Search Sidebar
  // document.querySelectorAll('.toggle-search') ? document.querySelectorAll('.toggle-search').forEach((value) => {
  //   value.addEventListener('click', () => {
  //     document.body.classList.toggle('sidebar-active');
  //   })
  // }) : null;
  // Close Search Sidebar
  // document.querySelectorAll('.search-close') ? document.querySelectorAll('.search-close').forEach((value) => {
  //   value.addEventListener('click', () => {
  //     document.body.classList.remove('sidebar-active');
  //   })
  // }) : null;

  // Toggle loader when searching
  document.querySelector('.search-button') ? [].slice.call(document.querySelectorAll('.search-button')).forEach((value) => {
    value.addEventListener('click', () => {
      document.body.classList.remove('loaded')
    })
  }) : null;

//Dropdown Menu Toggle
var showMenu = function(){
    //div inside element contains dropdown menu
    var dropdown = this.parentNode.querySelector('div');
    var menuToggle = this;

    //if it's already active set it not to be
    if(dropdown.classList.contains("active")){
        dropdown.classList.toggle("active");
        menuToggle.classList.toggle("active");
        dropdown.classList.toggle("is-active");
        menuToggle.classList.toggle("is-active");
        return;
    }
    //get current active class
    var activeClass = document.querySelectorAll(".dropdown-menu .active");
    // make it not active
    if(activeClass!=null){
        for(var i=0; i<activeClass.length; i++){
          activeClass[i].classList.toggle("active");
          activeClass[i].classList.toggle("is-active");
        }
    }

    //apply active to the div inside element that contains dropdown menu
    dropdown.classList.toggle("active");
    dropdown.classList.toggle("is-active");
    menuToggle.classList.toggle("active");
    menuToggle.classList.toggle("is-active");
}

var menuDropdown = document.querySelectorAll(".dropdown-menu > a");

for(var i=0; i<menuDropdown.length; i++){
  menuDropdown[i].addEventListener('click', showMenu, false);
}

//faqs
// var faqSearch = document.querySelector('.faq-search input');
//
// if(faqSearch !== null){
//   faqSearch.addEventListener('keyup', function(e){
//     var results = document.getElementById('faq-results');
//     if(this.value.length != 0){
//       results.classList.add("active");
//     } else {
//       results.classList.remove("active");
//     }
//   });
// }

//More Options Toggle
// var classname = document.querySelectorAll(".more-options");
//
// var moreOptions = function(e) {
// 	e.preventDefault();
//   var element = document.getElementById("vehicle-search");
//   element.classList.toggle("active");
//   if(element.classList.contains('active')){
//     this.innerHTML = 'Hide additional options';
//   } else {
//     this.innerHTML = 'Show me more options';
//   }
// };
//
// for (var i = 0; i < classname.length; i++) {
//     classname[i].addEventListener('click', moreOptions, false);
// }

//Tab Content
function openTab(e, tabName) {
  let tabContent = document.querySelectorAll('.deal-tabs .tab-content');
  let tabLinks = document.querySelectorAll('.deal-tabs .tab');

  tabLinks.forEach((v) => {
    (v === e.target) ? e.target.classList.toggle('active') : v.classList.remove('active')
  });
  tabContent.forEach((v) => {
    (v.id === tabName) ? document.getElementById(tabName).classList.toggle('active') : v.classList.remove('active')
  });

}

//Search for Cars or Vans
// function showDesc(el){
//   el.style.display = 'none';
//   el.parentNode.querySelector('.extra').classList.remove('visuallyhidden');
// }

/**
  * SEARCH
  */
function searchType(elem, searchType) {
  var hiddenField, searchTab;

  //set hidden field value
  hiddenField = document.getElementById("search-type");
  hiddenField.setAttribute('value', searchType);

  //change header text
  let headerSpan = document.getElementsByClassName("header-span");
  for (let i = 0; i < headerSpan.length; i++) {
    (searchType === 'car') ? headerSpan[i].innerHTML = 'Car Lease' : headerSpan[i].innerHTML = 'Van Lease';
  }

  //remove active class
  searchTab = document.getElementsByClassName("search-tab");
  for (i = 0; i < searchTab.length; i++) {
    searchTab[i].className = searchTab[i].className.replace(" active", "");
  }

  //add active class to clicked
  elem.classList.toggle("active");

  loadManufacturers(document.querySelector('#search-type').value);
  loadBodyTypes(document.querySelector('#search-type').value);

  var dropdown = document.getElementsByName('model')[0];
  dropdown.length = 0;

  var defaultOption = document.createElement('option');
  defaultOption.text = 'Any Model';
  defaultOption.value = '';

  dropdown.add(defaultOption);
  dropdown.selectedIndex = 0;
}

function loadManufacturers($type) {
  let make_dropdowns = document.querySelectorAll('[name="make"]');
  for (i = 0; i < make_dropdowns.length; i++) {
    let dropdown = make_dropdowns[0];
    dropdown.length = 0;

    let defaultOption = document.createElement('option');
    defaultOption.text = 'Any Make';
    defaultOption.value = '';

    dropdown.add(defaultOption);
    dropdown.selectedIndex = 0;

    let url = '/api/'+$type+'/manufacturers';

    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' + response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]];
          option.value = keysSorted[x];
          dropdown.add(option);
      }
      (dropdown.dataset.selected) ? dropdown.value = dropdown.dataset.selected : null;
    }).catch(function(err) {
        console.error('Fetch Error -', err);
    });
  }
}

function loadModels($type, $manufacturer) {
  var model_dropdowns = document.getElementsByName("model");
  for (let i = 0; i < model_dropdowns.length; i++) {
    var dropdown = model_dropdowns[i];
    dropdown.length = 0;

    var defaultOption = document.createElement('option');
    defaultOption.text = 'Any Model';
    defaultOption.value = '';

    dropdown.add(defaultOption);
    dropdown.selectedIndex = 0;

    var url = '/api/'+$type+'/models/'+$manufacturer;

    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      for (let x in keysSorted) {
        let option = document.createElement('option');
        option.text = data[keysSorted[x]];
        option.value = keysSorted[x];
        dropdown.add(option);
      }
    }).catch(function(err) {
        console.error('Fetch Error -', err);
    });
  }

}

function loadSpecs($type, $model) {
  var dropdown = document.getElementsByName('spec')[0];
  dropdown.length = 0;

  var defaultOption = document.createElement('option');
  defaultOption.text = 'Any Spec';
  defaultOption.value = '';

  dropdown.add(defaultOption);
  dropdown.selectedIndex = 0;

  var url = '/api/'+$type+'/specs/'+$model;

  fetch(url).then(function(response) {
    if (response.status !== 200) {
      console.warn('Looks like there was a problem. Status Code: ' +
        response.status);
      return;
    }
    return response.json();
  }).then(function(data) {
    let keysSorted = Object.keys(data).sort(function(a, b) {
      return data[a].localeCompare(data[b])
    });
    for (let x in keysSorted) {
      let option = document.createElement('option');
      option.text = data[keysSorted[x]];
      option.value = keysSorted[x];
      dropdown.add(option);
    }
  }).catch(function(err) {
      console.error('Fetch Error -', err);
  });

}

function loadBodyTypes($type) {
  var dropdown = document.getElementsByName('body_type')[0];

  if(typeof dropdown == 'undefined'){
    return false;
  }

  dropdown.length = 0;

  var defaultOption = document.createElement('option');
  defaultOption.text = 'Any Bodytype';
  defaultOption.value = '';

  dropdown.add(defaultOption);
  dropdown.selectedIndex = 0;

  var url = '/api/'+$type+'/types';

  fetch(url).then(function(response) {
    if (response.status !== 200) {
      console.warn('Looks like there was a problem. Status Code: ' +
        response.status);
      return;
    }
    return response.json();
  }).then(function(data) {
    let keysSorted = Object.keys(data).sort(function(a, b) {
      return data[a].localeCompare(data[b])
    });
    for (let x in keysSorted) {
      let option = document.createElement('option');
      option.text = data[keysSorted[x]];
      option.value = keysSorted[x];
      dropdown.add(option);
    }
  }).catch(function(err) {
      console.error('Fetch Error -', err);
  });
}

// if(document.getElementById('email-signup')){
//   document.getElementById('email-signup').addEventListener("click", function(e) {
//     e.preventDefault();
//
//     let url = '/newsletter';
//     let email = document.getElementById('newsletter-email').value;
//     let name = document.getElementById('newsletter-name').value;
//     let token = document.getElementsByName('_token')[0].value;
//
//     fetch(url, {
//       method: 'POST', // or 'PUT'
//       body: JSON.stringify({ 'name': name, 'first_name': name, 'email': email, '_token': token }), // data can be `string` or {object}!
//       headers:{
//         'Content-Type': 'application/json'
//       }}).then(function(response) {
//       if (response.status !== 200) {
//         console.warn('Looks like there was a problem. Status Code: ' +
//           response.status);
//         return;
//       }
//       return response.json();
//     }).then(function(data) {
//       if(data.status!='ok'){
//         let errors = '';
//         for (var i in data.errors) {
//           errors += data.errors[i][0]+'\n';
//         }
//         return alert('There was a problem with your sign up details\n\n'+$errors);
//       }
//
//       document.getElementsByClassName('newsletter-form')[0].reset();
//       document.cookie = "newsletter_dismissed=true";
//
//       // Trigger event tracking
//       window.dataLayer = window.dataLayer || [];
//       window.dataLayer.push({
//         'event': 'Newsletter Form Submit'
//       });
//       return alert('Thank you!');
//
//     }).catch(function(err) {
//       console.error('Fetch Error -', err);
//     });
//   });
// }

function loadSearchForm () {
  // Load Search Form
  if(document.getElementsByClassName('search-form').length>0){
    // Search
    let searchType = document.querySelector('#search-type').value;

    loadManufacturers(searchType);

    document.querySelector('.search-form [name=make]').addEventListener("change", function(e){
      loadModels(document.querySelector('#search-type').value, e.target.value);
    });
  }
}

window.onload = (function(){
  //preloader
  var root = document.getElementsByTagName('html')[0];
  root.classList.add("site-loaded");
  document.body.classList.add("loaded");
  loadSearchForm();
});


document.addEventListener('DOMContentLoaded', () => {
  // Fix Margin Derivative
  let dealDetail = document.querySelector('.derivative-wrapper > .deal-detail');
  if (dealDetail) {
    setTimeout(function () {
      let trackHeight = dealDetail.querySelector('.gallery-track-ctr').offsetHeight;
      dealDetail.setAttribute('style', `margin-bottom:-${trackHeight}px`);
      window.onresize = function(event) {
        trackHeight = dealDetail.querySelector('.gallery-track-ctr').offsetHeight;
        dealDetail.setAttribute('style', `margin-bottom:-${trackHeight}px`);
      }
    }, 1000);
  }

  //Lazy Load Images
  let lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
  let active = false;
  const lazyLoad = function() {
    if (active === false) {
      active = true;

      lazyImages.forEach(function(lazyImage) {
        if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
          lazyImage.src = lazyImage.dataset.src;
          // lazyImage.srcset = lazyImage.dataset.srcset;
          lazyImage.classList.remove("lazy");

          lazyImages = lazyImages.filter(function(image) {
            return image !== lazyImage;
          });

          if (lazyImages.length === 0) {
            document.removeEventListener("scroll", lazyLoad);
            window.removeEventListener("resize", lazyLoad);
            window.removeEventListener("orientationchange", lazyLoad);
          }
        }
      });

      active = false;
    }
  };
  document.addEventListener("scroll", lazyLoad);
  window.addEventListener("resize", lazyLoad);
  window.addEventListener("orientationchange", lazyLoad);
  lazyLoad();

  // Deal Box Slider
  // const dealBoxSlider = [].slice.call(document.querySelectorAll('.offers-strip:not(.derivative-page) .offers-strip-ctr'))
  // if (dealBoxSlider) {
  //   dealBoxSlider.forEach((e) => {
  //     let sliderID = e.parentElement.parentElement.getAttribute('id')
  //     new Glider(e, {
  //       slidesToScroll: 1,
  //       slidesToShow: 1,
  //       draggable: true,
  //       scrollLock: true,
  //       arrows: {
  //         prev: '.offers-strip#'+sliderID+' .glider-prev',
  //         next: '.offers-strip#'+sliderID+' .glider-next'
  //       },
  //       responsive: [
  //         {
  //           breakpoint: 767,
  //           settings: {
  //             slidesToShow: 2,
  //           }
  //         },
  //         {
  //           breakpoint: 1200,
  //           settings: {
  //             slidesToShow: 3,
  //           }
  //         }
  //       ]
  //     })
  //   })
  // }

  // Reviews Slider
  const reviewsSlider = document.querySelector('.reviews-wrapper');
  if (reviewsSlider) {
    const glider = new Glider(reviewsSlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      scrollLock: true,
      rewind: true,
      draggable: true,
      dots: '#dots'
    });
    sliderAuto(glider, 8000);
  }

  // Vehicle Slider
  const vehicleSlider = document.querySelector('#vehicle-slider');
  const vehicleSlides = document.querySelectorAll('#vehicle-slider > .slide');
  const vehicleSliderDots = document.querySelectorAll('#vehicle-dots > .glider-dot');
  if (vehicleSlider) {
    vehicleSliderDots.forEach(value => {
      value.addEventListener('click', (e) => {
        vehicleSliderDots.forEach(v => { v.classList.remove('active') });
        e.target.classList.add('active');
        vehicleSlides.forEach(v => { (e.target.dataset.index === v.dataset.index) ? v.classList.add('active') : v.classList.remove('active') });
      })
    })
  }

  // Featured Ranges Slider
  // const sidebarSlider = document.querySelector('#sidebar-offers .sidebar-offers-track');
  // if (sidebarSlider) {
  //   const glider = new Glider(sidebarSlider, {
  //     slidesToScroll: 1,
  //     slidesToShow: 1,
  //     draggable: true,
  //     scrollLock: true,
  //     arrows: {
  //       prev: '.sidebar-offers-arrows .glider-prev',
  //       next: '.sidebar-offers-arrows .glider-next'
  //     },
  //     responsive: [
  //     {
  //       breakpoint: 769,
  //       settings: { slidesToShow: 2 }
  //     },
  //     {
  //       breakpoint: 1100,
  //       settings: { slidesToShow: 1 }
  //     }
  //   ]
  //   })
  //   sliderAuto(glider, 20000);
  // }

  // Manufacturers Slider
  // const manufacturersSlider = document.querySelector('.manufacturer-strip-ctr');
  // if (manufacturersSlider) {
  //   const gliderManufacturers = new Glider(manufacturersSlider, {
  //     slidesToScroll: 1,
  //     slidesToShow: 2.5,
  //     scrollLock: false,
  //     rewind: true,
  //     draggable: true,
  //     responsive: [
  //       {
  //         breakpoint: 480,
  //         settings: {
  //           slidesToShow: 4,
  //         }
  //       },
  //       {
  //         breakpoint: 767,
  //         settings: {
  //           slidesToShow: 5,
  //         }
  //       },
  //       {
  //         breakpoint: 1200,
  //         settings: {
  //           slidesToShow: 6,
  //         }
  //       }
  //     ]
  //   });
  //   sliderAuto(gliderManufacturers, 3000);
  // }

  // Derivative Gallery Slider
  const dealGallerySlider = document.querySelector('.deal-gallery-track');
  if (dealGallerySlider) {
    new Glider(dealGallerySlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: true,
      scrollLock: true,
      arrows: {
        prev: '.deal-gallery-controls .glider-prev',
        next: '.deal-gallery-controls .glider-next'
      },
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 5,
          }
        }
      ]
    })
  }

  // Auto-slide helper function
  function sliderAuto(slider, milliseconds) {
    const slidesCount = slider.track.childElementCount;
    let slideTimeout = null;
    let nextIndex = 1;

    function slide() {
      slideTimeout = setTimeout(
        function () {
          if (nextIndex >= slidesCount ) {
            nextIndex = 0;
          }
          slider.scrollItem(nextIndex++);
        },
        milliseconds
      );
    }

    slider.ele.addEventListener('glider-animated', function() {
      window.clearInterval(slideTimeout);
      slide();
    });

    slide();
  }

// Toggle class for accordions
  let acc = document.getElementsByClassName('mobile-accordion-header');
  for (let i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function(ev) {

      for (let i = 0; i < acc.length; i++) {
        if (acc[i] === this || acc[i].parentElement.parentElement !== this.parentElement.parentElement || this.parentElement.classList.contains('no-close')) {
          continue;
        }
        acc[i].parentElement.classList.remove('active');
      }

      if (!this.parentElement.classList.contains('active') && !this.parentElement.classList.contains('no-scroll')){
        setTimeout(() => { document.documentElement.scrollTop += this.getBoundingClientRect().top; }, 500);
      }
      this.parentElement.classList.toggle("active");

    });
  }

  // Close modals on orientation changes
  window.addEventListener("orientationchange", function() {
    modalMobileNav.close();
    modalMobileSearch.close();
    hamburgerSearch.classList.remove('is-active');
    hamburger.classList.remove('is-active');
    navContainer.classList.remove('is-active');
  }, false);

  // Table Sorting
  // function sortTable(elem) {
  //   let sortName = elem.composedPath()[0].dataset.sortname;
  //   let sortDirection = elem.composedPath()[0].dataset.sortdirection;
  //   let tableBody = elem.composedPath()[3].childNodes[3];
  //   let tableRows = Array.from(tableBody.children);
  //
  //   let sortRows = (dir) => [...tableRows].filter(row => (sortName !== 'price' && row.dataset[sortName].length) || (sortName === 'price' && row.dataset.price !== 'POA')).sort(function (a, b) {
  //     a = a.dataset[sortName];
  //     b = b.dataset[sortName];
  //     return (dir === 'asc') ? b.localeCompare(a) : a.localeCompare(b);
  //   });
  //
  //   if (sortDirection.length && sortDirection === 'asc') {
  //     [].slice.call(document.querySelectorAll('.table-sort')).forEach((el) => el.setAttribute('data-sortdirection', ''));
  //     elem.composedPath()[0].setAttribute('data-sortdirection', 'desc');
  //     let sortTable = sortRows('desc').forEach(function (value) {
  //       value.remove();
  //       tableBody.prepend(value);
  //     });
  //   } else {
  //     [].slice.call(document.querySelectorAll('.table-sort')).forEach((el) => el.setAttribute('data-sortdirection', ''));
  //     elem.composedPath()[0].setAttribute('data-sortdirection', 'asc');
  //     let sortTable = sortRows('asc').forEach(function (value) {
  //       value.remove();
  //       tableBody.prepend(value);
  //     });
  //   }
  // }

  // Sort Model Table
  //let sortHeaders = document.querySelectorAll('#model-table .model-table-head .table-sort[data-sortName]');
  //[...sortHeaders].forEach((value) => value.addEventListener('click', (val) => sortTable(val)));

  // Header - Show More
  const showMoreButton = document.querySelector('#show-more');
  if(showMoreButton){
    if (showMoreButton.parentElement.querySelectorAll('.header-description > p').length > 1) {
      showMoreButton.addEventListener('click', (e) => {
        e.target.parentElement.classList.add('header-content--full');
      })
    } else {
      showMoreButton.parentElement.classList.add('header-content--full');
    }
  }
});
